import {
  LocalProductsBanner,
  LocalProductsBannerProps
} from '@smuchile/pkg-unimarc-components'

interface ILocalProductsBannerContent extends LocalProductsBannerProps {
  isIntersectingProductsBanner: boolean
}

export const LocalProductsBannerContent = ({
  backgroundColor,
  buttonLabel,
  description,
  imagesSrcs,
  isIntersectingProductsBanner,
  linkWrapper,
  title,
  onClick
}: ILocalProductsBannerContent) => {
  return (
    <>
      {isIntersectingProductsBanner && (
        <LocalProductsBanner
          backgroundColor={backgroundColor}
          buttonLabel={buttonLabel}
          description={description}
          imagesSrcs={imagesSrcs}
          linkWrapper={linkWrapper}
          onClick={onClick}
          title={title}
        />
      )}
    </>
  )
}
